import { GetterTree } from 'vuex';
import { RootState } from '../types';
import { AxiosState } from './types';

// export interface GettersType {}

export const getters: GetterTree<AxiosState, RootState> /*& GettersType*/ = {

};
